module.exports = __webpack_public_path__ + "static/media/alliance-for-watershed-education.48f674fd.md";